/* eslint object-shorthand: 0 */
import $ from 'jquery';

function showTab(lastActiveHeight) {
	const $container = $('.js-tabWrap.is-tab-open');
	const $body = $container.find('.line-tab__body');
	const $content = $container.find('.line-tab__content');
	const contentHeight = $content.outerHeight(true);
	const posTop = $container.offset().top;
	const topSpaceToScroll = 100;

	/* change height of tab content */
	$body.animate({
		height: contentHeight,
	}, 400);
	/* fade in content */
	$content.fadeIn(300);

	$('html, body').animate({
		scrollTop: (posTop - topSpaceToScroll) - lastActiveHeight,
	}, 500, 'swing');
}
function hideTab() {
	const $container = $('.js-tabWrap.is-tab-open');
	const $body = $container.find('.line-tab__body');
	const $content = $container.find('.line-tab__content');

	/* just hide the tab and content */
	$body.animate({
		height: 0,
	}, 400);
	$content.fadeOut(300);
}

$('.js-tabToggle').on('click', function tabActions(e) {
	e.preventDefault();

	/* get targets */
	const target = this.hash || $(this).attr('data-href');
	const $target = $(`a[href="${target}"], [data-href="${target}"]`);

	/* safe last active tab */
	const lastActiveTab = $('.is-tab-open');
	let lastActiveHeight = 0;


	/* hide last active tab if is some */
	if (lastActiveTab.length > 0) {
		const lastIndex = $('.js-tabWrap.is-tab-open').index('.js-tabWrap');
		const currentIndex = $($target[0]).index('.js-tabToggle');
		lastActiveHeight = lastIndex < currentIndex ? $('.js-tabWrap.is-tab-open').find('.line-tab__body').outerHeight() : 0;
	}
	if (lastActiveTab.length > 0) {
		hideTab();
		lastActiveTab.removeClass('is-tab-open');
	}

	/* show clicked tab if it is not the same like the last actived */
	if (!$(this).is(lastActiveTab) && !$(this).closest('.line-tab').is(lastActiveTab)) {
		$target.each((i, el) => {
			if ($(el).closest('.js-tabWrap').length > 0) {
				$(el).closest('.js-tabWrap').addClass('is-tab-open');
			} else {
				$(el).addClass('is-tab-open');
			}
		});
		showTab(lastActiveHeight);
	}
});



// WEBPACK FOOTER //
// ./frontend/js/tabs.js